import { useEffect } from "react";
import classNames from "classnames";
import { useForm } from "react-hook-form";
import { useExpensesState } from "atoms/expensesAtom";

import { BoldText } from "components/BoldText/BoldText";
import { BaseLayout } from "components/BaseLayout/BaseLayout";

import styles from "./styles.module.scss";
import { SalaryFooter } from "./SalaryFooter";
import { SalaryBody } from "./SalaryBody";

export type FormSalaryValues = {
  name: string;
  position: string;
  isTerminal: boolean;
  articleid: string;
};

const Header = ({ title }): JSX.Element => (
  <BoldText className={styles.groupTitle}>
    {title || "Новая статья затрат"}
  </BoldText>
);

export const Salary = (): JSX.Element => {
  const { expensesState } = useExpensesState();

  const { handleSubmit, control, reset } = useForm<FormSalaryValues>({
    defaultValues: {
      name: "",
      position: "99",
      isTerminal: false,
      articleid: "",
    },
  });

  useEffect(() => {
    reset({
      name: expensesState.activeItem ? expensesState.activeItem.name : "",
      position: expensesState.activeItem
        ? expensesState.activeItem.position + ""
        : "99",
      isTerminal: expensesState.activeItem
        ? expensesState.activeItem.showonfront === 1
        : false,
      articleid: expensesState.activeItem
        ? expensesState.activeItem.articleid
        : "",
    });
  }, [expensesState]);

  return (
    <BaseLayout
      className={classNames("ml-2 mt-3 mb-3", styles.container)}
      header={<Header title={expensesState.activeItem?.name} />}
      footer={<SalaryFooter onSubmit={handleSubmit} />}
    >
      <SalaryBody
        control={control}
        isEdit={Boolean(expensesState.activeItem)}
      />
    </BaseLayout>
  );
};
